export const ActionTypes = {
  REQUEST: "FETCH_LIST_GOALS_REQUEST",
  SUCCESS: "FETCH_LIST_GOALS_SUCCESS",
  FAILURE: "FETCH_LIST_GOALS_FAILURE",
}
